export enum ConsoleSettingTab {
    ALARM_GROUPS = 'console-settings.tab.alarm-groups',
}
